import { Base } from "../core/base.model";
import { Puesto } from "../empleado/puesto.model";

export class Area extends Base{
    id: number;
    area: String;
    estatus: String;
    defaultService: boolean;
    listPuesto: Puesto[];
    tipo: String;
    idTicketSolicitud: number;
}
